import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import TableGrouping, { IColumnsGrouping } from '../../components/table-grouping/TableGrouping';
import AppContext from '../../../AppContext';
import { getListWorkDay } from '../../category/services/symbolServices';
import { RESPONSE_STATUS_CODE, TYPE_REF, VARIABLE_STRING } from '../../constants/moduleConsts';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import { toast } from "react-toastify";
import Autocomplete from '../../components/input/autocomplete';
// import { CODE_WEEKEND, NUMBER_SHEET_TIMESHEET_OVERVIEW } from '../constants/timesheetConsts';
import { variantStandardStyle } from '../../components/input/autocomplete/styleJS';
import { checkWeekend, checkWeekendOrHoliday } from '../../utils/functionUtils';
import { CODE_WEEKEND, NUMBER_SHEET_TIMESHEET_OVERVIEW } from '../../timesheet/constants/timesheetConsts';
import { TYPE_TIMEKEEPING_SYNTHETIC } from '../constants/timekeepingOverviewConsts';

const TableTimesheetsSynthetic = (props: any) => {
    const {data, pageable, handleClick = (data: any) => { }, searchObject, setSearchObject = (data: any) => { }, noPagination = false } = props;
    const { setPageLoading } = useContext(AppContext);
    const { lang } = useMultiLanguage();

    const listAttribution = [
        { name: "Đi làm", type: TYPE_TIMEKEEPING_SYNTHETIC.DI_LAM },
        { name: "Nghỉ", type: TYPE_TIMEKEEPING_SYNTHETIC.NGHI },
        { name: "Đi học", type: TYPE_TIMEKEEPING_SYNTHETIC.DI_HOC },
        { name: "Trực", type: TYPE_TIMEKEEPING_SYNTHETIC.TRUC },
        { name: "Nghỉ bù", type: TYPE_TIMEKEEPING_SYNTHETIC.NGHI_BU },
        { name: "Ốm", type: TYPE_TIMEKEEPING_SYNTHETIC.OM },
        { name: "Phép", type: TYPE_TIMEKEEPING_SYNTHETIC.PHEP },
        { name: "Chế độ hưởng bảo hiểm", type: TYPE_TIMEKEEPING_SYNTHETIC.CHE_DO_BAO_HIEM },
        { name: "Chế độ hưởng lương", type: TYPE_TIMEKEEPING_SYNTHETIC.CHE_DO_HUONG_LUONG },
    ]

    const columns = (): IColumnsGrouping[] => {
        const listColumn: IColumnsGrouping[] = [
            {
                name: "STT",
                field: "stt",
                render: (row: any, index: number, stt: number) => <span>{stt}</span>,
            },
            {
                name: "Khoa phòng",
                field: "phongBanText",
                headerStyle: {
                    minWidth: "300px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
        ];

        const listStatistical: IColumnsGrouping[] = [];
        listAttribution.forEach((attribution) => {
            listStatistical.push({
                name: attribution?.name,
                field: attribution?.name,
                headerStyle: {
                    minWidth: "100px"
                },
                render: (row: any) => {
                    const { types, phongBanId, phongBanText } = row;
                    const typeToFind = attribution.type;
                    const findType = types.find((synthetic: any) => synthetic.type === typeToFind);
                    if (findType) {
                        return <div
                            className="color-steel-blue fw-600 cursor-pointer"
                            onClick={() => handleClick({
                                ...findType,
                                phongBanId,
                                phongBanText
                            })}
                        >
                            {findType?.soLuong}
                        </div>
                    }
                    return <span>0</span>
                }
            })
        });

        listColumn.push({
            name: "Thống kê nhân sự",
            field: "statistical",
            headerStyle: {
                minWidth: "180px"
            },
            child: listStatistical
        });

        return listColumn;
    }

    const memoizedTable = useMemo(
        () => {
            setTimeout(() => setPageLoading(false), 10)
            return (
                <TableGrouping
                    className="table-custom table-timekeeping-synthetic"
                    id="timeSheets"
                    columns={columns()}
                    data={data}
                    prefixDataField="data"
                    prefixTitleField="phongBanText"
                    noPagination={noPagination}
                    totalElements={pageable.totalElements}
                    totalPages={pageable.totalPages}
                    numberOfElements={pageable.numberOfElements}
                    searchObject={searchObject}
                    setSearchObject={setSearchObject}
                />
            )
        },
        [data]
    );

    return (
        <div>{memoizedTable}</div>
    )
};

export default TableTimesheetsSynthetic;